// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".responders-heading[data-v-8559a5c2]{display:grid;grid-template-columns:auto 75px}.responder[data-v-8559a5c2],.responder .target-container[data-v-8559a5c2]{width:100%}.responder .target-container[data-v-8559a5c2] .unlabeled-select{min-width:35%;height:100%}.responder .target[data-v-8559a5c2]{height:100%}", ""]);
// Exports
module.exports = exports;
